import { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Loading from "../../components/Loading";
import Meta from "../../components/Meta";
import PasswordRequirements from '../../components/PasswordRequirements';

import Data from "../../../repository";
import { resetPasswordSchema } from '../../../validation/schemas';

import styles from "../../../styles/Entry.module.scss";

function ResetPassword() {
	const params = useParams();
	const navigate = useNavigate();

	const [loading, setLoading] = useState(false);
	const [serverError, setServerError] = useState(null);

	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
		watch
	} = useForm({
		resolver: yupResolver(resetPasswordSchema),
		defaultValues: {
			email: '',
			password: ''
		}
	});

	const onSubmit = async (data) => {
		setLoading(true);
		setServerError(null);

		try {
			await Data.resetPassword(data.email, data.password, params.token);
			navigate("../../");
		} catch (error) {
			reset();
			setServerError(error.response?.data?.message || 'An error occurred. Please try again.');
		} finally {
			setLoading(false);
		}
	}

	return (
		<>
			<Meta title="Reset Password" />

			<div>
				{serverError &&
					<div className={styles.error}>
						<p>{serverError}</p>
					</div>
				}

				<h1>Reset Password</h1>
				<p>Enter your email address and choose a new password below.</p>

				<form onSubmit={handleSubmit(onSubmit)}>
					<div>
						<input
							type="email"
							placeholder="Email Address"
							{...register('email')}
							maxLength={255}
							className={errors.email ? 'input-error' : ''}
						/>
						{errors.email && <p className={styles.fieldError}>{errors.email.message}</p>}
					</div>
					<div>
						<input
							type="password"
							placeholder="New Password"
							{...register('password')}
							maxLength={255}
							className={errors.password ? 'input-error' : ''}
						/>
						<PasswordRequirements password={watch('password')} />
					{errors.password && <p className={styles.fieldError}>{errors.password.message}</p>}
					</div>
					<button className="btn btnPrimary" disabled={loading}>
						{loading ?
							<Loading button={true} />
							:
							`Reset Password`
						}
					</button>
				</form>

				<div className={styles.alternatives}>
					<Link to="/entry/login">Remember your password?</Link>
				</div>
			</div>
		</>
	);
}

export default ResetPassword;
